import { Box, Flex, Text } from '@chakra-ui/react';
import { useMemo } from 'react';
import { useSearchParams } from 'react-router-dom';
import { DocumentViewerContainer } from 'src/components/FormField/DocViewer/DocumentViewerContainer';
import NavbarDashboard from 'src/components/NavbarDashboard';
import { PdfViewerContainer } from 'src/components/PdfViewer/PdfViewerContainer';
import { getFileViewerRequest } from 'src/utils/fileViewer';

const FileViewer = () => {
  const [searchParams] = useSearchParams();
  const requestId = searchParams.get('requestId');
  const storagePayload = useMemo(
    () => getFileViewerRequest(requestId),
    [requestId]
  );

  const fileUrl = storagePayload?.fileUrl ?? searchParams.get('fileUrl') ?? undefined;
  const fileExtension = useMemo(
    () =>
      storagePayload?.fileExtension?.toLowerCase() ??
      searchParams.get('fileExtension')?.toLowerCase() ??
      undefined,
    [searchParams, storagePayload?.fileExtension]
  );
  const submissionContextId =
    storagePayload?.submissionContextId ??
    searchParams.get('submissionContextId') ??
    undefined;
  const organizationId =
    storagePayload?.organizationId ?? searchParams.get('organizationId') ?? undefined;

  const isPdf = fileExtension === 'pdf';
  const isDoc = fileExtension === 'doc' || fileExtension === 'docx';

  return (
    <Flex direction="column"  gap={4} bg="white" minHeight="100vh">
      <NavbarDashboard  submissionContextId={submissionContextId}/>
      {!fileUrl || !fileExtension ? (
        <Box>
          <Text>Missing file information.</Text>
        </Box>
      ) : isPdf ? (
        <PdfViewerContainer
          fileUrl={fileUrl}
          fileExtension={fileExtension}
          submissionContextId={submissionContextId}
          organizationId={organizationId}
        />
      ) : isDoc ? (
        <DocumentViewerContainer
          fileUrl={fileUrl}
          fileExtension={fileExtension}
          submissionContextId={submissionContextId}
          organizationId={organizationId}
        />
      ) : (
        <Box>
          <Text>
            This file type is not supported in viewer. Please download/open the
            file directly.
          </Text>
        </Box>
      )}
    </Flex>
  );
};

export default FileViewer;
